<template>
  <div>
    <app-header title="Template Types">
      <b-button
        v-router-link="{ name: 'templatetype-editor' }"
        variant="primary"
      >
        <i class="fa fa-plus-circle" /> New Template Type
      </b-button>
    </app-header>
    <b-container class="mt-5">
      <b-row>
        <b-col>
          <search-input v-model="query" />
        </b-col>
        <b-col class="text-right"> {{ totalRows }} Template Types </b-col>
      </b-row>
      <b-table
        id="template-type-table"
        :items="displayTemplates"
        :fields="fields"
        :busy="loading"
        show-empty
        striped
        hover
        responsive
        selectable
        select-mode="single"
        @row-selected="view"
      >
        <template v-slot:table-busy>
          <loading-spinner />
        </template>
        <template v-slot:cell(hidden)="data">
          {{ data.item.hidden ? '&#10003;' : '' }}
        </template>
      </b-table>
    </b-container>
  </div>
</template>

<script>
import $api from '@/services/api';
import $search from '@/services/search';

import LoadingSpinner from '@/components/LoadingSpinner';
import SearchInput from '@/components/SearchInput';
import AppHeader from '@/components/AppHeader';

export default {
  components: {
    AppHeader,
    LoadingSpinner,
    SearchInput,
  },

  data() {
    return {
      templateTypes: null,
      fields: [
        { key: 'id', label: 'ID', sortable: true },
        { key: 'name', label: 'Type Name', sortable: true },
        { key: 'codename', label: 'Codename', sortable: true },
        { key: 'hidden', label: 'Hidden', sortable: true },
      ],
      loading: false,
      query: null,
    };
  },

  computed: {
    totalRows() {
      return this.templateTypes && this.templateTypes.length;
    },

    displayTemplates() {
      return $search(this.templateTypes, this.query, [
        'name',
        'codename',
        'id',
      ]);
    },
  },

  created() {
    this.refreshData();
  },

  methods: {
    refreshData() {
      this.loading = true;
      $api
        .get('/v1/internal/templatetypes')
        .then((types) => {
          this.templateTypes = types;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    view(rows) {
      this.$router.push({
        name: 'templatetype-editor',
        query: { id: rows[0].id },
      });
    },
  },
};
</script>
